/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectWebPlan from 'modules/me/select-web-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewSubsription = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/shopify-development');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Shopify Development Plan' subTitle={'Hello ' + businessName} selected='shopify' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                    Our usual fixed price to develop a Shopify website is $7,990 with half paid up front and half on delivery. 
                    This monthly offer is for 14 equal monthly payments of $665.00 (inc GST) for 14 consecutive months. After the first month is paid we will start the development and deliver as quickly as possible, 
                    based on when you are ready with data images and text. Typically, a site will be ready in under a month.
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Shopify development plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectWebPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewSubsription);
